import type { IReduxState } from 'frontend/configureStore';
import { useSelector } from 'react-redux';
import { getLastOsasRequestWithMraReferralLetter } from '../../../../utils/getLastOsasc2RequestWithMraReferralLetter';
import { ResponsiveCard } from '../../molecules/card/Card';
import { PageSectionForCards } from '../../molecules/pageSection/PageSection';
import { OsasMraCard } from '../osasCards/OsasMraCard';

export function YourDataSegment() {
    const requestProcesses = useSelector((state: IReduxState) => state.authentication.requestProcesses);
    const mraReferralLetterRequest = getLastOsasRequestWithMraReferralLetter(requestProcesses);
    const userHasOsasMraReferralLetter = useSelector(
        (state: IReduxState) => state.authentication.userHasOsasMraReferralLetter
    );

    return (
        <PageSectionForCards
            chapterTitle="Je dossier"
            md={12}
        >
            {(mraReferralLetterRequest || userHasOsasMraReferralLetter) && (
                <OsasMraCard
                    key={6}
                    request={mraReferralLetterRequest}
                    userHasOsasMraReferralLetter={userHasOsasMraReferralLetter}
                />
            )}
            <ResponsiveCard
                body="Vraag hier jouw gegevens op uit ons systeem"
                cardTitle="Vraag je gegevens op"
                lg={12}
                linksText={['Vraag gegevens op']}
                linksTo={['/yourData']}
            />
        </PageSectionForCards>
    );
}
